import { Form, FormInstance, Select } from "antd";
import { useCallback, useMemo } from "react";
import { PAYEE_TYPES } from "../../../../../../../../../../lib/constants";
import { IOption } from "../../../../../../../../../../types/Option";

type TypeSelectProps = {
  form: FormInstance;
  isHistoryOpened: boolean;
  isPassthru: boolean | undefined;
  setIsRadioVisible: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPercentage: React.Dispatch<React.SetStateAction<boolean>>;
  isPayment?: boolean;
  isFormDisabled?: boolean;
};

export const TypeSelect = ({
  form,
  isHistoryOpened,
  isPassthru,
  setIsRadioVisible,
  setIsPercentage,
  isPayment,
  isFormDisabled
}: TypeSelectProps) => {
  const payeeTypes: IOption[] = useMemo(
    () =>
      PAYEE_TYPES.filter((item) => {
        if (item.value === 101) {
          return false;
        }

        if ([103, 104, 105].includes(item.value)) {
          return form.getFieldValue("type") === item.value;
        }

        return !isHistoryOpened ? item.value !== 102 : item.value !== 7;
      }),
    [isHistoryOpened, form]
  );

  const onSelectChange = useCallback(
    (e: number) => {
      const isDollarOnly: boolean = [5, 6].includes(e) && !isPassthru;

      const isPercentOnly: boolean = [0, 7].includes(e) && !isPayment;

      setIsRadioVisible(!isDollarOnly && !isPercentOnly);

      const nextIsPercentage: boolean = isDollarOnly
        ? false
        : isPercentOnly
          ? true
          : form.getFieldValue("amountSwitcher") === 2;

      setIsPercentage(nextIsPercentage);
    },
    [form, setIsPercentage, setIsRadioVisible, isPassthru, isPayment]
  );

  return (
    <Form.Item name="type" label="Payee Type" className="mb-4">
      <Select options={payeeTypes} onChange={onSelectChange} />
    </Form.Item>
  );
};
